export const TERMS_LINK = "https://www.securityjourney.com/terms-of-service";
export const HOME_LINK = "https://www.securityjourney.com";
export const PRIVACY_LINK = "https://www.securityjourney.com/privacy";
export const KNOWLEDGE_BASE_LINK = "https://help.securityjourney.com/";
